import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
  }
})

export default {
  [types.SET_GROUP] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.group = payload
  },
  [types.SET_GROUPS] (state, payload) {
    state.groups = payload.data
    state.pagination = payload.meta.pagination
  }
}
